import { useCallback } from 'react';

import { useCurrentLocale } from '#features/i18n';
import { formatDate } from '../utils/formatDate';
import { useUserTimeSettings } from './useUserTimeSettings';

export const useFormatDate = () => {
  const currentLocale = useCurrentLocale();
  const { timeZone, timeFormat } = useUserTimeSettings();

  return useCallback(
    (dateInput: string | Date, pattern: string) =>
      formatDate(dateInput, pattern, {
        locale: currentLocale,
        timeZone,
        timeFormat,
      }),
    [currentLocale, timeZone, timeFormat]
  );
};
